// extracted by mini-css-extract-plugin
module.exports = {"token":"O9Fak","link":"TQ7Ah","window":"h3jM4","recaptcha":"Hx2-7","buttons":"EBw60"};